var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23633 4.09917C1.11264 4.09917 1.0186 4.21033 1.0391 4.33232L2.99992 16H10.9999L12.9607 4.33232C12.9812 4.21033 12.8872 4.09917 12.7635 4.09917H1.23633ZM13.4666 1.32231C13.577 1.32231 13.6666 1.41186 13.6666 1.52231V2.44463C13.6666 2.55509 13.577 2.64463 13.4666 2.64463H0.533252C0.422795 2.64463 0.333252 2.55509 0.333252 2.44463V1.52231C0.333252 1.41186 0.422795 1.32231 0.533252 1.32231H4.14059C4.74059 1.32231 5.22792 0.595703 5.22792 0H8.77192C8.77192 0.595703 9.25859 1.32231 9.85925 1.32231H13.4666Z",
    fill: "#849291"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6235421eddd699b85ec2201de7aafcf1.svg";
export { ForwardRef as ReactComponent };